import Sprite from "app/components/sprite";
import { useAnimation } from "app/hooks/useAnimation";
import { useI18nLanguage } from "app/hooks/i18n";
import arabicCurrentMonthGrowth from "app/images/section-images/features/arabic/current-month-growth.png";
import arabicCustomers from "app/images/section-images/features/arabic/customers.png";
import arabicOrderValue from "app/images/section-images/features/arabic/order-value.png";
import arabicPendingPayments from "app/images/section-images/features/arabic/pending-payments.png";
import arabicRepeatPurchases from "app/images/section-images/features/arabic/repeat-purchases.png";
import currentMonthGrowth from "app/images/section-images/features/current-month-growth.png";
import customersSm from "app/images/section-images/features/customers-sm.png";
import customers from "app/images/section-images/features/customers.png";
import girlUsingPhone from "app/images/section-images/features/girl-using-phone-and-misc.png";
import manUsingPhone from "app/images/section-images/features/man-using-phone.png";
import orderValue from "app/images/section-images/features/order-value.png";
import pendingPayments from "app/images/section-images/features/pending-payments.png";
import repeatPurchasesSm from "app/images/section-images/features/repeat-purchases-sm.png";
import repeatPurchases from "app/images/section-images/features/repeat-purchases.png";
import womanUsingPhone from "app/images/section-images/features/woman-using-phone.png";
import { useRef } from "react";
import { Trans } from "react-i18next";

export const FeaturesHeroSection = () => {
  const customersImg = useRef(null);
  const customersImgSm = useRef(null);
  const { locale: language } = useI18nLanguage();

  useAnimation([customersImg, customersImgSm]);

  return (
    <section id="hero" className="bg-primary md:h-[90vh] md:max-h-[692px]">
      <div
        className="relative z-[48] flex h-full
        w-full flex-col-reverse md:block"
      >
        <div
          className="relative z-[1] h-[540px] w-full
          md:absolute md:left-0 md:top-0 md:h-full"
        >
          <div className="h-full w-full overflow-hidden">
            <div className="zbooni-layout h-full w-full">
              <div className="relative h-full w-full">
                <img
                  src={womanUsingPhone}
                  alt="woman-using-phone"
                  className="absolute top-0 z-[1] hidden max-w-[296px] transform
                  rounded-2xl ltr:left-0 rtl:right-0 rtl:scale-x-[-1] md:top-[388px]
                  md:block ltr:md:left-[-120px] rtl:md:right-[-120px]"
                />
                <img
                  src={language == "ar" ? arabicOrderValue : orderValue}
                  alt="order-value"
                  className="absolute top-0 z-[2] hidden max-w-[190.45px]
                  transform ltr:left-0 rtl:right-0 md:top-[489.7px]
                  md:block ltr:md:left-[84.39px] rtl:md:right-[84.39px]"
                />
                <div
                  className="relative top-0 z-[3] h-full w-full
                  transform ltr:left-0 rtl:right-0 md:top-[74px]
                  ltr:md:left-[485px] rtl:md:right-[485px]"
                >
                  <Sprite
                    name="feature-hero-ellipse"
                    className="animate__animated animate__fadeInLeft
                    absolute top-3 z-[1] h-[566px] w-[566px] transform
                    ltr:left-2 rtl:right-2 md:h-[706px] md:w-[706px]
                    ltr:md:left-0 rtl:md:right-0"
                  />
                  <div className="animate__animated animate__fadeInRight">
                    <img
                      src={manUsingPhone}
                      alt="man-using-phone"
                      className="absolute top-[56px] z-[2] max-w-[226px]
                      transform ltr:left-[-58px] rtl:right-[-58px]
                      rtl:scale-x-[-1] md:top-[5px] md:max-w-[322px] 
                      ltr:md:left-[80px] rtl:md:right-[80px] lg:top-[42px]
                      ltr:lg:left-[155px] rtl:lg:right-[155px]"
                    />
                  </div>
                  <img
                    src={
                      language == "ar"
                        ? arabicCurrentMonthGrowth
                        : currentMonthGrowth
                    }
                    alt="current-month-growth"
                    className="absolute top-[33px] z-[3] max-w-[121.81px]
                    transform ltr:left-[147px] rtl:right-[147px] md:top-[73px]
                    md:max-w-[142px] ltr:md:left-3 rtl:md:right-3
                    ltr:lg:left-[82px] rtl:lg:right-[82px]"
                  />
                  <img
                    src={
                      language == "ar" ? arabicPendingPayments : pendingPayments
                    }
                    alt="pending-payments"
                    className="absolute top-[108.82px] z-[3] max-w-[135px]
                    transform ltr:left-[107px] rtl:right-[107px] md:top-[161px]
                    md:max-w-[149px] ltr:md:left-[-31px] rtl:md:right-[-31px]
                    ltr:lg:left-[41px] rtl:lg:right-[41px]"
                  />
                  <div className="animate__animated animate__fadeInUp">
                    <img
                      src={girlUsingPhone}
                      alt="girl-using-phone"
                      className="absolute top-[200px] z-[4] max-w-[387px] 
                      transform ltr:left-0 rtl:right-0 rtl:scale-x-[-1] 
                      md:top-56 md:max-w-[560px] ltr:md:left-[-180px]
                      rtl:md:right-[-180px] lg:top-40 ltr:lg:-left-40
                      rtl:lg:-right-40 xl:top-20 ltr:xl:left-60 rtl:xl:right-60"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute z-[3] h-full w-full">
          <div className="zbooni-layout relative h-full w-full">
            <img
              src={language == "ar" ? arabicRepeatPurchases : repeatPurchases}
              alt="repeat-purchases"
              className="absolute top-[710px] z-[6] max-w-[118px]
              transform overflow-hidden rounded-2xl shadow-card-light
              ltr:hidden rtl:left-[145px] rtl:block md:top-[600px]
              rtl:md:left-32 lg:top-[550px] lg:max-w-[170.56px]
              ltr:lg:right-[208px] ltr:lg:block rtl:lg:left-[208px] 
              xl:top-[476px] ltr:xl:right-[218px] rtl:xl:left-[218px]"
            />
            <img
              src={language == "ar" ? arabicCustomers : customers}
              alt="customers"
              className="animate__animated absolute bottom-[-75px] 
              top-[560px] max-w-[120px] overflow-hidden opacity-0
              shadow-card-light ltr:right-[30px] ltr:hidden rtl:left-[35px] 
              rtl:block md:top-[500px] ltr:md:block lg:top-[380px] 
              lg:max-w-[206.58px] ltr:lg:right-[50px] rtl:lg:left-[50px]
              xl:top-[330px] ltr:xl:right-[85px] rtl:xl:left-[85px]"
              ref={customersImg}
              data-animation="animate__fadeInDown"
            />
            <img
              src={customersSm}
              alt="customers"
              className="animate__animated absolute left-[62%]
              top-[77%] z-[1] max-w-[118px] translate-x-[225px]
              translate-y-[16%] transform opacity-0 shadow-card-light
              ltr:block rtl:hidden ltr:md:hidden"
              ref={customersImgSm}
              data-animation="animate__fadeInDown"
            />
            <img
              src={repeatPurchasesSm}
              alt="customers"
              className="absolute bottom-0 left-0 z-[2] max-w-[102px]
              translate-x-[168px] translate-y-[24%] transform
              shadow-card-light ltr:block rtl:hidden md:bottom-[5%]
              md:left-[50%] ltr:lg:hidden"
            />
          </div>
        </div>
        <div className="relative z-[2] h-full w-full overflow-hidden">
          <div className="zbooni-layout">
            <div className="mt-[90px] md:mt-[120px] lg:mt-[133px]">
              <h1
                className="max-w-xs text-[40px] font-black leading-[50px] 
                text-white md:max-w-sm lg:text-[45px] lg:leading-[55px]
                xl:max-w-md"
              >
                <Trans>Your business in your hands.</Trans>
              </h1>
              <h2
                className="mt-[26px] max-w-xs text-[21px] font-medium
                leading-[30px] text-white md:max-w-sm md:text-[18px]
                lg:text-[22px] lg:leading-[34px] xl:max-w-md"
              >
                <Trans>
                  Everything you need to compete, succeed and thrive at your
                  fingertips.
                </Trans>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
